var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"w-100 my-1",attrs:{"text":"","color":"primary","disabled":!_vm.isFileExists()},on:{"click":function($event){return _vm.downloadFile()}}},[_c('span',{staticClass:"second-text"},[_c('v-icon',[_vm._v("mdi-download")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }